import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import classNames from "classnames";
import queryString from 'query-string';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Search from "@material-ui/icons/Search";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import {searchPolls} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';
import SearchGrid from 'components/SearchGrid/SearchGrid.jsx';

import bokeh1080 from "assets/img/background/bokeh1080.jpg";

import searchPageStyle from "assets/jss/material-kit-react/views/searchPage.jsx";

class SearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
    };
  }

  componentDidMount() {
    this.getQueryFromUrl();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.search !== prevProps.location.search) {
      this.getQueryFromUrl();
    }
  }

  getQueryFromUrl() {
    const searchVals = queryString.parse(this.props.location.search);
    const q = searchVals.q ? searchVals.q : '';
    this.setState({query: q});
    if (q) {
      this.props.searchPolls(q);
    }
  }

  clickSearchBtn = e => {
    e.preventDefault();
    const {query} = this.state;
    const {searchPolls, history} = this.props;
    if (query.length < 3) {
      alert('You must search for something at least 3 characters long!')
    } else {
      searchPolls(query);
      history.push({pathname: "/poll/search", search: `?q=${query}`});
    }
  }

  updateSearchField = event => {
    this.setState({ query: event.target.value });
  };

  resetSearch() {
    this.setState({query: ''});
    this.props.history.push("/poll/search");
  }

  renderResetBtn() {
    const {classes, logoutUser} = this.props;
      return (
        <div className={classes.resetContainer}>
          <Button
            color="transparent"
            className={classes.resetBtn}
            onClick={() => this.resetSearch()}
          >
            <p className={classes.resetTxt}>
              clear
            </p>
          </Button>
        </div>
      );
  }

  renderSearchInput() {
    const {classes} = this.props;
    return (
      <div>
        <form onSubmit={this.clickSearchBtn}>
          <CustomInput
            // white
            search
            id="searchq"
            inputRootCustomClasses={classes.inputRootCustomClasses}
            formControlProps={{
              className: classes.formControl
            }}
            inputProps={{
              placeholder: "search for limitless pollibilities",
              value: this.state.query,
              onChange: this.updateSearchField,
              inputProps: {
                name: "search",
                type: "text",
                "aria-label": "Search",
                className: classes.searchInput
              }
            }}
          />
            {/* <Button justIcon round color="white" onClick={() => this.clickSearchBtn()}> */}
            <Button justIcon round color="white" type="submit">
              <Search className={classes.searchIcon} />
            </Button>
        </form>

      </div>
    );
  }

  renderSearchResults() {
    const {classes, poll} = this.props;
    const {query} = this.state;
    const isStateQuerySameAsResults = (query && poll.qresults.query && query === poll.qresults.query);

    if (poll.searching) {
      return <LoadingSpinner />;
    } else if (poll.qresults.query && poll.qresults.polls.length === 0) {
      const noResStr = `No results found for "${poll.qresults.query}"! Try a new search?`;
      const noResStr2 = "If no polls exist yet, create one!";
      return (
        <div className={classes.resultsContainer}>
          <p className={classes.searchResTxt}>{noResStr}</p>
          <p style={{marginTop: 10}} className={classes.searchResTxt}>{noResStr2}</p>
        </div>
      );
    } else if (isStateQuerySameAsResults && poll.qresults.query !== "%") {
      const showResStr = `Showing search results for: "${poll.qresults.query}"`;
      return (
        <div className={classes.resultsContainer}>
          <p className={classes.searchResTxt}>{showResStr}</p>
          {this.renderResetBtn()}
          <GridContainer justify="center">
            <GridItem xs={12} className={classes.navWrapper}>
              <SearchGrid searchData={poll.qresults.polls}/>
            </GridItem>
          </GridContainer>
        </div>
      );
    } else {
      return (
        <div className={classes.resultsContainer}>
          <p className={classes.searchResTxt}>Everybody's searching for something</p>
        </div>
      );
    }
  }

  render() {
    const {classes, history, auth, ...rest} = this.props;

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={bokeh1080}>
          <div className={classes.titleContainer}>
            <h1 className={classes.searchTitle}>Search Polls</h1>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.bodyContainer}>
              <GridContainer justify="center">
                <GridItem xs={12} lg={10} >
                  <div className={classes.resultsContainer}>
                    <div className={classes.searchInputContainer}>
                      {this.renderSearchInput()}
                    </div>
                    <div className={classes.txtCol}>
                      {this.renderSearchResults()}
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    poll: state.poll,
  };
}

const pageWithStyles = withStyles(searchPageStyle)(SearchPage);

// export default pageWithStyles;
export default withRouter(connect(mapStateToProps, {searchPolls})(pageWithStyles));



// WEBPACK FOOTER //
// ./src/views/SearchPage.js